(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("classNames"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "classNames", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["ne"] = factory(require("React"), require("classNames"), require("ReactDOM"));
	else
		root["ne"] = factory(root["React"], root["classNames"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 